import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaLongArrowAltLeft, FaRegEyeSlash } from "react-icons/fa";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { Link } from "react-router-dom";
import { commonToast } from "../helper/Toast";
import { ApiPut } from "../helper/axiosFunctions";
import Loading from "../components/Loading";

export default function ChangePasswordPage() {
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(false);
  const [isHide, setIsHide] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const userData = JSON.parse(localStorage?.getItem("zubrus_user_data"))?.data;

  const validateForm = () => {
    const validationErrors = {};
    if (!oldPassword)
      validationErrors.oldPassword = t("validation.oldPasswordRequired");
    if (!newPassword)
      validationErrors.newPassword = t("validation.newPasswordRequired");
    // else if (newPassword.length < 6)
    //   validationErrors.newPassword = t("passwordvalidation");
    return validationErrors;
  };

  const handleSubmit = async () => {
    setLoading(true);
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      const response = await ApiPut("/auth/password/change", {
        userId: userData?.userInfo?.userId,
        newPassword,
      });
      setLoading(false);
      if (response.code === 200) {
        commonToast(t("passwordChanged"), "success");
      }
    } catch (error) {
      setLoading(false);
      setErrors({});
      commonToast(
        error?.data?.error || error?.message || "password Change Failed",
        "error"
      );
    }
  };

  return (
    <div className="max-w-md mx-auto py-10 md:px-4">
      <div className="flex items-center md:gap-2 mb-10">
        <Link
          to="/profile"
          className="border cursor-pointer rounded-full flex justify-center items-center size-10"
        >
          <FaLongArrowAltLeft />
        </Link>
        <h3 className="text-lg font-bold flex-1 text-center">
          {t("changepassword")}
        </h3>
      </div>

      <div className="relative flex items-center">
        <input
          name="oldPassword"
          type={isShow ? "text" : "password"}
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          placeholder={`${t("current")} ${t("password")}`}
          className={`border h-[56px] w-full relative rounded-xl bg-transparent px-4 py-2 shadow-inner outline-none placeholder:text-gray-500 text-black tracking-widest ${errors.oldPassword ? "border-red-500" : ""
            }`}
        />
        {isShow ? (
          <MdOutlineRemoveRedEye
            className="absolute cursor-pointer right-5 text-xl"
            onClick={() => setIsShow(!isShow)}
          />
        ) : (
          <FaRegEyeSlash
            className="absolute cursor-pointer right-5 text-xl"
            onClick={() => setIsShow(!isShow)}
          />
        )}
      </div>
      {errors.oldPassword && (
        <p className="text-red-500 text-sm mt-1">{errors.oldPassword}</p>
      )}

      <div className="relative flex items-center mt-5">
        <input
          name="newPassword"
          type={isHide ? "text" : "password"}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder={`${t("new")} ${t("password")}`}
          className={`border h-[56px] w-full relative rounded-xl bg-transparent px-4 py-2 shadow-inner outline-none placeholder:text-gray-500 text-black tracking-widest ${errors.newPassword ? "border-red-500" : ""
            }`}
        />
        {isHide ? (
          <MdOutlineRemoveRedEye
            className="absolute cursor-pointer right-5 text-xl"
            onClick={() => setIsHide(!isHide)}
          />
        ) : (
          <FaRegEyeSlash
            className="absolute cursor-pointer right-5 text-xl"
            onClick={() => setIsHide(!isHide)}
          />
        )}
      </div>
      {errors.newPassword && (
        <p className="text-red-500 text-sm mt-1">{errors.newPassword}</p>
      )}

      <button onClick={handleSubmit} className="primary-btn w-full mt-5">
        {loading ? <Loading /> : t("changepassword")}
      </button>
    </div>
  );
}
